import { MessageCircle } from 'lucide-react';
import { useT } from '@/lib/i18n';
import { useSupportContact, waLink } from '@/stores/support';

/** The green WhatsApp help button — only on the four main tabs (Bible 13.1). */
export function FloatingHelp() {
  const { t } = useT();
  const c = useSupportContact();
  return (
    <a href={waLink(c.whatsapp, t('আমার একটা সাহায্য লাগবে', 'I need some help'))} target="_blank" rel="noreferrer" aria-label={t('WhatsApp-এ সাহায্য নিন', 'Get help on WhatsApp')}
      className="fixed bottom-24 right-4 z-30 flex h-12 w-12 items-center justify-center rounded-full bg-wa text-white shadow-float active:scale-95 md:right-[calc(50%-23rem)] lg:bottom-6 lg:right-6">
      <MessageCircle size={26} />
    </a>
  );
}
